import React, { useContext, useEffect, useState } from 'react'
import Heading from '../../../Components/Heading/Heading'
import { useLocation, useNavigate } from 'react-router-dom'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';
import moment from "moment";
import SelectForm from '../../../Components/SelectForm/SelectForm';
import InputForm from '../../../Components/InputForm/InputForm';
import DynamicGrid from '../../../Components/DynamicGrid/DynamicGrid';
import { getContext, LoaderContext } from '../../../Helpers/Context/Context';
import { APICall } from '../../../Helpers/API/APICalls';
import { getClassificationdropdown, getEmployeeDropdown, getEmployeeProductivityById,
   getLowProductivityReasonDropdown, getProductivityByIdForEdit, getProductivityInnerGridData, getSkillSetDropdown, 
   insertupdateProductivity} from '../../../Helpers/API/APIEndPoints';
import notify from '../../../Helpers/ToastNotification';

const ProductivityCreate = () => {

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const lastDayOfPreviousMonth = new Date(currentYear, currentMonth, 0);

    const localDate = moment().subtract(1, "months").startOf("month");
    const localDateFormatted = localDate.format("YYYY-MM-DD");
   
    const { EmployeeId, RoleId } = getContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [FormErrors, setFormErrors] = useState<any>({});
    const { showLoader, hideLoader } = useContext(LoaderContext);
    const [date, setDate] = useState<any>(localDateFormatted);//moment().subtract(1, "months").endOf("month").toDate()
    const [employeeDropdown, setEmployeeDropdown] = useState<any>([]);
    const [selectedEmployee, setSelectedEmployee] = useState<any>([]);
    const [reportingManager, setReportingManager] = useState<any>({});
    const [workingDays, setWorkingDays] = useState<any>()
    const [notFilled, setNotFilled] = useState<any>()
    const [discrepancy, setDiscrepancy] = useState<any>();
    const [planHrs, setPlanHrs] = useState<any>();
    const [actualHrs, setActualHrs] = useState<any>();
    const [productivity, setProductivity] = useState<any>();
    const [lastmonthProductivity, setLastmonthProductivity] = useState<any>()
    const [primarySkillDropdown, setPrimarySkillDropdown] = useState<any>([]);
    const [selectedPrimarySkill, setSelectedPrimarySkill] = useState<any>([]);
    const [productivityClassification, setProductivityClassification] = useState<any>([]);
    const [selectedProductivityClassification, setSelectedProductivityClassification] = useState<any>([]);
    const [lowProductivityReason, setLowProductivityReason] = useState<any>([]);
    const [selectedLowProductivityReason, setSelectedLowProductivityReason] = useState<any>([]);
    const [remark, setRemark] = useState<any>()
    const [isActive, setIsActive] = useState<boolean>(true)
    const [editData, setEditData] = useState<any>([])
    const [innerGridData, setInnerGridData] = useState<any>([])
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [start, setStart] = useState(0);
    const [sortColumn, setSortColumn] = useState("");
    const [sortDirection, setSortDirection] = useState("");
    const [searchText, setSearchText] = useState("");
    const [count, setCount] = useState(0);


    useEffect(()=>{
        getDataById()
      },[location.state,productivityClassification,primarySkillDropdown,lowProductivityReason])

    useEffect(
      ()=>{
        
        //setDate(moment(currentDate).startOf('month').format('YYYY-MM-DD'));
        //setDate(moment().subtract(1, "months").endOf("month").toDate());
       // setDate(localDateFormatted);
        GetEmployees(); 
        GetPrimarySkillSet();
        GetClassification();
        GetReasons();
        //getProductivityInnerGrid();
      },[])

    useEffect(
        ()=>{
          setFormErrors({})
          if(selectedEmployee && !location.state){
            getEmployeeProductivityDetails();
            
          }
         
        
      },[selectedEmployee,date])

    useEffect(
        ()=>{
          getProductivityInnerGrid()
        }
        ,[selectedEmployee,searchText,
          date,
          sortColumn,
          sortDirection,
          start,
          page,
          pageSize,])

      useEffect(
        ()=>{

          if(editData && location.state){
          //console.log('edit data useeffect=>',editData)
          setDate(editData?.productivityDate)
          const parsedWorkingDays = parseFloat(editData?.workingDays);
          setWorkingDays(parsedWorkingDays);
          setIsActive(editData?.isActive)
            
          const parsedNotFilledDays = parseFloat(editData?.notFilledDays);
          setNotFilled(parsedNotFilledDays);

          const parsedDiscrepancyDays = parseFloat(editData?.discrepancyDays);
          setDiscrepancy(parsedDiscrepancyDays);

          const parsedTotalPlannedHours = parseFloat(editData?.totalPlannedHours);
          setPlanHrs(parsedTotalPlannedHours);

          const parsedTotalActualHours = parseFloat(editData?.totalActualHours);
          setActualHrs(parsedTotalActualHours);

          setProductivity(editData?.productivity);
          setLastmonthProductivity(editData?.lastMonthProductivity);


          }
        }
        ,[editData,location.state])

    const getDataById = async()=>{

      if(location.state){
        showLoader()
        let obj = {
          Id : location.state
        }
        const {data} = await APICall(getProductivityByIdForEdit,"POST",obj)
        // console.log('edit data=>',data)

        if(data) {

          setEditData(data)

          // const parsedWorkingDays = parseFloat(data?.workingDays);
          // setWorkingDays(isNaN(parsedWorkingDays) ? 0 : parsedWorkingDays);

          // const parsedNotFilledDays = parseFloat(data?.notFilledDays);
          // setNotFilled(isNaN(parsedNotFilledDays) ? 0 : parsedNotFilledDays);

          // const parsedDiscrepancyDays = parseFloat(data?.discrepancyDays);
          // setDiscrepancy(isNaN(parsedDiscrepancyDays) ? 0 : parsedDiscrepancyDays);

          // const parsedTotalPlannedHours = parseFloat(data?.totalPlannedHours);
          // setPlanHrs(isNaN(parsedTotalPlannedHours) ? 0 : parsedTotalPlannedHours);

          // const parsedTotalActualHours = parseFloat(data?.totalActualHours);
          // setActualHrs(isNaN(parsedTotalActualHours) ? 0 : parsedTotalActualHours);

          // setProductivity(data?.productivity || 0);
          // setLastmonthProductivity(data?.lastMonthProductivity || 0);

          // setWorkingDays(data?.workingDays);
          // setNotFilled(data?.notFilledDays);
          // setDiscrepancy(data?.discrepancyDays);
          // setPlanHrs(data?.totalPlannedHours);
          // setActualHrs(data?.totalActualHours);
          // setProd uctivity(data?.productivity);
          // setLastmonthProductivity(data?.lastMonthProductivity);
          setRemark(data?.remark);
          setSelectedEmployee({value : data?.employeeId , label : data?.employeeName})
          setReportingManager({value : data?.managerId, label : data?.reportingManagerName})

          const matchingObj = productivityClassification?.find((ele) => ele.value == data?.productivityClassificationId);
          //const matchObj = lowProductivityReason?.find((ele) => ele.value == data?.lowProductivityReasonId);

          //console.log('matchingObj=>',matchingObj,'matchObj=>',matchObj)
          setSelectedProductivityClassification(matchingObj)
          

            const idsArray = data?.primarySkillSetIds.split(',').map(id => id.trim());
            const matchedObjs = primarySkillDropdown?.filter((ele) => {
              return idsArray.includes(ele.value.toString().trim());  
            });
            setSelectedPrimarySkill(matchedObjs);

            const idsArray2 = data?.lowProductivityReasonId.split(',').map(id => id.trim());
            const matchObj = lowProductivityReason?.filter((ele) => {
              return idsArray2.includes(ele.value.toString().trim());  
            });
            setSelectedLowProductivityReason(matchObj);

        }
        hideLoader()
      }
      

    }

    const GetEmployees = async()=>{
      let Role;
        if(RoleId.includes("3")){
          Role = 3
        }else if(RoleId.includes("8")){
           Role = 8
        }
      let obj = {
        RoleId : Role ? Role : 0,
        EmployeeId : EmployeeId,

      }
      
      const {data} = await APICall(getEmployeeDropdown,"POST",obj);
      //console.log('employee DD=>',data);
      if(data){

        const arr =  data?.map((ele)=>{
          return{
            value : ele.employeeId,
            label : ele.employeeName,
          }
        })

        setEmployeeDropdown(arr)
      }

    }

    const GetPrimarySkillSet = async()=>{
     
      const {data} = await APICall(getSkillSetDropdown,"POST",{})
      //console.log('skillset dd==>',data)
      if(data){
        const arr =  data?.map((ele)=>{
          return {
            label :ele.primarySkillName,
            value : ele.primarySkillSetIds,
          }
        })
         setPrimarySkillDropdown(arr);
      }
    }

    const GetClassification = async()=>{
      let obj = {

      }
      const {data} = await APICall(getClassificationdropdown,"POST",{})
      //console.log('classification dd==>',data)
      if(data){
        const arr =  data?.map((ele)=>{
          return {
            label :ele.classificationName,
            value : ele.productivityClassificationId,
          }
        })
        setProductivityClassification(arr);
      }
    }

    const GetReasons = async()=>{
      let obj = {

      }
      const {data} = await APICall(getLowProductivityReasonDropdown,"POST",{})
     // console.log('reason dd==>',data)
      if(data){
        const arr =  data?.map((ele)=>{
          return {
            label :ele.lowProductivityReasonName,
            value : ele.lowProductivityReasonId,
          }
        })
        setLowProductivityReason(arr);
      }
    }

    const getEmployeeProductivityDetails = async()=>{
        showLoader()
      let obj = {
        ProductivityDate : date? date :null,
        EmployeeId : selectedEmployee ? selectedEmployee.value : null,
      }
      //console.log(obj,' date => ',date)
       const {data} = await APICall(getEmployeeProductivityById,"POST",obj);
       // console.log('productivity details==>',data);
       if(data){
        let obj = {
            value : data[0]?.managerId,
            label : data[0]?.reportingManagerName,
        }

        setReportingManager(obj);
        setWorkingDays(data[0]?.workingDays);
        setNotFilled(data[0]?.notFilledDays);
        setDiscrepancy(data[0]?.discrepancyDays);
        setPlanHrs(data[0]?.totalPlannedHours);
        setActualHrs(data[0]?.totalActualHours);
        setProductivity(data[0]?.productivity);
        setLastmonthProductivity(data[0]?.lastMonthProductivity);


       }
       hideLoader()
    }

    const onSubmitValidation = async()=>{
      await setFormErrors({})
      if (selectedEmployee == null || !selectedEmployee || Object.keys(selectedEmployee).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["selectedEmployee_isEmpty"]: "This is mandatory field",
        }));
        FormErrors["selectedEmployee_isEmpty"] =
          "This is mandatory field";
      }
  
      if (!date) {
        setFormErrors((preState) => ({
          ...preState,
          ["date_isEmpty"]: "This is mandatory field",
        }));
        FormErrors["date_isEmpty"] = "This is mandatory field";
      }

      // if (!reportingManager) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["reportingManager_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["reportingManager_isEmpty"] = "This is mandatory field";
      // }

      // if(!workingDays){
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["workingDays_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["workingDays_isEmpty"] = "This is mandatory field";
      // }

      // if(!notFilled){
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["notFilled_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["notFilled_isEmpty"] = "This is mandatory field";
      // }

      // if(!discrepancy){
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["discrepancy_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["discrepancy_isEmpty"] = "This is mandatory field";
      // }

      // if(!planHrs){
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["planHrs_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["planHrs_isEmpty"] = "This is mandatory field";
      // }

      // if(!actualHrs){
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["actualHrs_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["actualHrs_isEmpty"] = "This is mandatory field";
      // }

      // if(!productivity){
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["productivity_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["productivity_isEmpty"] = "This is mandatory field";
      // }

      // if(!lastmonthProductivity){
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["lastmonthProductivity_isEmpty"]: "This is mandatory field",
      //   }));
      //   FormErrors["lastmonthProductivity_isEmpty"] = "This is mandatory field";
      // }

      if(!selectedPrimarySkill || Object.keys(selectedPrimarySkill).length === 0){
        setFormErrors((preState) => ({
          ...preState,
          ["selectedPrimarySkill_isEmpty"]: "This is mandatory field",
        }));
        FormErrors["selectedPrimarySkill_isEmpty"] = "This is mandatory field";
      }

      if(!selectedProductivityClassification || Object.keys(selectedProductivityClassification).length === 0){
        setFormErrors((preState) => ({
          ...preState,
          ["selectedProductivityClassification_isEmpty"]: "This is mandatory field",
        }));
        FormErrors["selectedProductivityClassification_isEmpty"] = "This is mandatory field";
      }

      if(selectedProductivityClassification && selectedProductivityClassification.value == 3)
      {
        if(!selectedLowProductivityReason || Object.keys(selectedLowProductivityReason).length === 0){
          setFormErrors((preState) => ({
            ...preState,
            ["selectedLowProductivityReason_isEmpty"]: "This is mandatory field",
          }));
          FormErrors["selectedLowProductivityReason_isEmpty"] = "This is mandatory field";
        }
      }

    
      if(!remark || Object.keys(remark).length === 0){
        setFormErrors((preState) => ({
          ...preState,
          ["remark_isEmpty"]: "This is mandatory field",
        }));
        FormErrors["remark_isEmpty"] = "This is mandatory field";
      }

    }

    const selectOnChange = (event:any, apiFieldName:any)=>{
        
      if(apiFieldName === "selectedEmployee"){
          setSelectedEmployee(event);
      
          if (event && Object.keys(event).length > 0) {
            setFormErrors((preState) => ({
              ...preState,
              ["selectedEmployee_isEmpty"]: undefined,
            }));
          } else if (!event || Object.keys(event).length === 0) {
            setFormErrors((preState) => ({
              ...preState,
              ["selectedEmployee_isEmpty"]: "This is mandatory field",
            }));
          }
          
      }

      if(apiFieldName === "selectedPrimarySkill"){
        setSelectedPrimarySkill(event);
    
        if (event && Object.keys(event).length > 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["selectedPrimarySkill_isEmpty"]: undefined,
          }));
        } else if (!event || Object.keys(event).length === 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["selectedPrimarySkill_isEmpty"]: "This is mandatory field",
          }));
        }     
     }

      if(apiFieldName === "selectedProductivityClassification"){

        setSelectedProductivityClassification(event);
    
        if (event && Object.keys(event).length > 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["selectedProductivityClassification_isEmpty"]: undefined,
          }));
        } else if (!event || Object.keys(event).length === 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["selectedProductivityClassification_isEmpty"]: "This is mandatory field",
          }));
        }     
      }

      if(apiFieldName === "selectedLowProductivityReason"){
      
        setSelectedLowProductivityReason(event);

        if(selectedProductivityClassification && selectedProductivityClassification.value ==3)
        {
          if (event && Object.keys(event).length > 0) {
            setFormErrors((preState) => ({
              ...preState,
              ["selectedLowProductivityReason_isEmpty"]: undefined,
            }));
          } else if (!event || Object.keys(event).length === 0) {
            setFormErrors((preState) => ({
              ...preState,
              ["selectedLowProductivityReason_isEmpty"]: "This is mandatory field",
            }));
          }     
        }
    
       
      }

    }

    const handleTextEvent = (event:any , apiFieldName:any)=>{

      if(apiFieldName === "remark"){
        setRemark(event.target.value);
        if ( event.target.value && event.target.value !== "" && event.target.value.toString().trim() !== ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["remark_isEmpty"]: undefined,
          }));
        } else if (
          !event.target.value ||
          event.target.value === "" ||
          event.target.value.toString().trim() === ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["remark_isEmpty"]: "This is mandatory field",
          }));
        }
      }

    }

    const onClickFunction = async(event:any , apiFieldName:any)=>{

        if(apiFieldName === 'reset'){
         // console.log('form Error=>',FormErrors)    
          setDate(localDateFormatted);
          setSelectedEmployee([]);
          setReportingManager("");
          setWorkingDays("");
          setNotFilled("");
          setDiscrepancy("");
          setPlanHrs("");
          setActualHrs("");
          setProductivity("");
          setLastmonthProductivity("");
          setSelectedPrimarySkill([]);
          setSelectedProductivityClassification([]);
          setSelectedLowProductivityReason([]);
          setRemark("")
          setFormErrors({})
        }

        else if(apiFieldName === 'submit'){
            
            showLoader();
            event.preventDefault();
            await onSubmitValidation();
            const isEmpty = await Object.values(FormErrors).every(
              (x) => x === null || x === "" || x == undefined
            );

          if(isEmpty){
            const primaryId = selectedPrimarySkill ? selectedPrimarySkill.map((ele) => ele.value).join(", "): 0;
            const reasonId = selectedLowProductivityReason ? selectedLowProductivityReason.map((ele) => ele.value).join(", ") :0
            
            let obj = {
              Id : location.state? location.state : 0,
              ProductivityDate : date,
              EmployeeId : selectedEmployee ? selectedEmployee?.value : null,
              ManagerId : reportingManager ? reportingManager?.value : null,
              WorkingDays : workingDays,
              NotFilledDays : notFilled,
              DiscrepancyDays : discrepancy,
              TotalPlannedHours : planHrs,
              TotalActualHours : actualHrs,
              Productivity : productivity,
              LastMonthProductivity : lastmonthProductivity,
              PrimarySkillSetIds : primaryId,
              ProductivityClassificationId : selectedProductivityClassification ? selectedProductivityClassification?.value :null,
              LowProductivityReasonId : reasonId,
              Remark : remark,
              IsActive : isActive,
              CreatedBy : EmployeeId,

            }
            console.log('reqobj=>',obj)

            const data = await APICall(insertupdateProductivity,"POST",obj)
           // console.log('data after submit==>',data)
            if(data?.data?.id != null){
              notify(0,'Data Saved Sccessfully')
              navigate(-1)
            }
            else if(data?.message === "Productivity present"){
              notify(1,'Record is already present for the selected employee and selected month')
            }else{
              notify(1,'Data Insertion failed!!!')
            }

          }
          hideLoader();
        }
    }

    const handleDateChange = (newDate) => {
      
      const formattedDate = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
    
      
      const utcDate = new Date(Date.UTC(formattedDate.getFullYear(), formattedDate.getMonth(), formattedDate.getDate()));
      const dateToSend = utcDate.toISOString().split('T')[0]; // YYYY-MM-DD
    
     // console.log("Sending formatted date:", dateToSend);
      setDate(dateToSend);
      
    };

    const options = {
      selectableRows: "none",
      count: count,
      rowsPerPage: pageSize,
      serverSide: true,
      rowsPerPageOptions: [],
      download: false,
      print: false,
      viewColumns: false,
      filter: false,
      search: true,
  
      setCellHeaderProps: () => ({ align: "center" }),
  
      onChangeRowsPerPage: (num) => {
        //   setLimit(num);
        //   setNxtPgInfo("");
        //   setPrevPgInfo("");
        //   setIsPrevOrNext("");
      },
      onSearchChange: (searchText) => {
        if (searchText !== null) {
          setSearchText(searchText);
          setStart(0);
        } else {
          setSearchText("");
        }
      },
      onColumnSortChange: async (sortColumn, sortDirection) => {
        if (sortDirection === "asc") {
          await setSortColumn(sortColumn);
          await setSortDirection(sortDirection);
        }
        if (sortDirection === "desc") {
          await setSortColumn(sortColumn);
          await setSortDirection(sortDirection);
        }
      },
      onChangePage: async (page) => {
        setStart(page * pageSize);
      },
      // // showCustomToolbar ?
      // customToolbar: () => {
      //   return (
      //     <FormControl sx={{ mt: 1 }}>
      //       <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
      //       <Select
      //         labelId="demo-simple-select-helper-label"
      //         id="demo-simple-select-helper"
      //         label="Active"
      //         value={isactive}
      //         onChange={handleChange}
      //         sx={{
      //           width: 80,
      //           height: 30, // Set the desired height
      //           "&:focus": { color: "success.main" }, // Change text color to green on focus
      //         }}
      //       >
      //         <MenuItem value={"All"}>All</MenuItem>
      //         <MenuItem value={"active"}>Yes</MenuItem>
      //         <MenuItem value={"inactive"}>No</MenuItem>
      //       </Select>
      //     </FormControl>
      //   );
      // },
    };

    const gridColumns = [
      {
        name: "id",
        label: "Id",
        options: {
          display: false,
          filter: false,
          sort: false,
        },
      },
      {
        name: "engagement",
        label: "Engagement",
        options: {
          filter: false,
          sort: true,
          sortDescFirst: true,
        },
      },
      {
        name: "requirement",
        label: "Requirement",
        options: {
          filter: false,
          sort: true,
          sortDescFirst: true,
        },
      },
      {
        name: "task",
        label: "Task",
        options: {
          filter: false,
          sort: true,
          sortDescFirst: true,
          // customBodyRender: (value) => (
          //   <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          //     {value}
          //   </div>
          // ),
        },
      },
      {
        name: "plannedHours",
        label: "Plan Hrs",
        options: {
          filter: false,
          sort: false,
          sortDescFirst: true,
          setCellProps: () => ({
            align: "right",
          }),
          setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
          // customBodyRender: (value) => {
          //   return <div style={{ paddingLeft: "50px" }}>{value}</div>;
          // },
        },
      },
      {
        name: "actualHours",
        label: "Actual Hrs",
        options: {
          filter: false,
          sort: false,
          sortDescFirst: true,
          setCellProps: () => ({
            align: "right",
          }),
          setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
          // customBodyRender: (value) => {
          //   return <div style={{ paddingLeft: "50px" }}>{value}</div>;
          // },
        },
      },
    ]

    const getProductivityInnerGrid = async()=>{

      let obj = {
        ProductivityDate : date,
        EmployeeId : selectedEmployee ? selectedEmployee?.value : null,
        start: start,
        pageSize: pageSize,
        sortColumn: sortColumn,
        sortOrder:  sortDirection,
        searchText: searchText,
      }
     // console.log('inner obj=>',obj)
     const  {data} = await APICall(getProductivityInnerGridData,"POST",obj);
     // console.log('data inner=>',data)
     if(data){
        setInnerGridData(data)
        setCount(data[0]?.count)
     }else{
      setPage(0);
      setStart(0);
      setCount(0);
      setInnerGridData([])
     }
    }
      

  return (
    <>
      <Heading title={"Productivity"}/>
      <div className="container-fluid">

        <div className='row'>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                  <label className="d-block">
                    Date <sup>*</sup>
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      views={["year", "month"]}
                      label="Year and Month"
                      value={date}
                      disabled ={location.state ? true : false}
                     // minDate = {null}
                      maxDate={lastDayOfPreviousMonth}
                      onChange={(e) => {
                        handleDateChange(e)
                      }}
                      renderInput={(params) => (
                        <TextField size="small" {...params} />
                      )}
                    />
                  </LocalizationProvider>

              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                  <label>
                    Name <sup>*</sup>
                  </label>
                  <SelectForm
                    placeholder={"Select Name"}
                    value={selectedEmployee}
                    options={employeeDropdown}
                    onChange={(event) => selectOnChange(event, "selectedEmployee")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                    isDisabled = {location.state ? true : false}

                  />
                <p style={{ color: "red" }}>{FormErrors["selectedEmployee_isEmpty"]}</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label>Reporting Manager 
                    {/* <sup>*</sup> */}
                    </label>
                   <InputForm
                      placeholder={"Reporting Manager"}
                      isDisabled={true}
                      textArea={false}
                      value={ reportingManager ? reportingManager.label:""}
                      onChange={(event) =>
                        handleTextEvent(event, "reportingManager")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["reportingManager_isEmpty"]}</p> */}
              </div>
            </div> 

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label>Working Days 
                    {/* <sup>*</sup> */}
                   </label>
                   <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={workingDays}
                      className="numRight"
                      onChange={(event) =>
                        handleTextEvent(event, "workingDays")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["workingDays_isEmpty"]}</p> */}
              </div>
            </div> 

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label>Not Filled Days 
                    {/* <sup>*</sup> */}
                   </label>
                   <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={notFilled}
                      className="numRight"
                      onChange={(event) =>
                        handleTextEvent(event, "notFilled")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["notFilled_isEmpty"]}</p> */}
              </div>
            </div> 

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label>Discrepancy Days 
                    {/* <sup>*</sup> */}
                    </label>
                   <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={discrepancy}
                      className="numRight"
                      onChange={(event) =>
                        handleTextEvent(event, "discrepancy")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["discrepancy_isEmpty"]}</p> */}
              </div>
            </div> 

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label>Total Plan Hrs 
                    {/* <sup>*</sup> */}
                    </label>
                   <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={planHrs}
                      className="numRight"
                      onChange={(event) =>
                        handleTextEvent(event, "planHrs")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["planHrs_isEmpty"]}</p> */}
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label>Total Actual Hrs 
                    {/* <sup>*</sup> */}
                    </label>
                   <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={actualHrs}
                      className="numRight"
                      onChange={(event) =>
                        handleTextEvent(event, "actualHrs")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["actualHrs_isEmpty"]}</p> */}
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label>Productivity 
                    {/* <sup>*</sup> */}
                    </label>
                   <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={productivity}
                      className="numRight"
                      onChange={(event) =>
                        handleTextEvent(event, "productivity")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["productivity_isEmpty"]}</p> */}
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">

                   <label> Last Month Productivity 
                    {/* <sup>*</sup> */}
                   </label>
                   <InputForm
                      placeholder={""}
                      isDisabled={true}
                      textArea={false}
                      value={lastmonthProductivity}
                      className="numRight"
                      onChange={(event) =>
                        handleTextEvent(event, "lastmonthProductivity")
                      }
                   />
                  {/* <p style={{ color: "red" }}>{FormErrors["lastmonthProductivity_isEmpty"]}</p> */}
              </div>
            </div>
            
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                  <label>
                    Skillsets <sup>*</sup>
                  </label>
                  <SelectForm
                    placeholder={"Select Skillsets"}
                    value={selectedPrimarySkill}
                    options={primarySkillDropdown}
                    onChange={(event) => selectOnChange(event, "selectedPrimarySkill")}
                    isMulti={true}
                    noIndicator={false}
                    noSeparator={false}

                  />
                <p style={{ color: "red" }}>{FormErrors["selectedPrimarySkill_isEmpty"]}</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                  <label>
                    Productivity Classification <sup>*</sup>
                  </label>
                  <SelectForm
                    placeholder={"Select Productivity"}
                    value={selectedProductivityClassification}
                    options={productivityClassification}
                    onChange={(event) => selectOnChange(event, "selectedProductivityClassification")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}

                  />
                <p style={{ color: "red" }}>{FormErrors["selectedProductivityClassification_isEmpty"]}</p>
              </div>
            </div>
            { selectedProductivityClassification && selectedProductivityClassification.value ==3 ?
            (
                <>
                  <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                  <label>
                    Low Productivity Reason <sup>*</sup>
                  </label>
                  <SelectForm
                    placeholder={"Select Reason"}
                    value={selectedLowProductivityReason}
                    options={lowProductivityReason}
                    onChange={(event) => selectOnChange(event, "selectedLowProductivityReason")}
                    isMulti={true}
                    noIndicator={false}
                    noSeparator={false}

                  />
                <p style={{ color: "red" }}>{FormErrors["selectedLowProductivityReason_isEmpty"]}</p>
              </div>
            </div>
                </>
            )
            :
            (
                <>
                  <div className="col-lg-4 col-md-4 col-sm-6">
                     <div className="form-group">
                  <label>
                    Low Productivity Reason 
                  </label>
                  <SelectForm
                    placeholder={"Select Reason"}
                    value={selectedLowProductivityReason}
                    options={lowProductivityReason}
                    onChange={(event) => selectOnChange(event, "selectedLowProductivityReason")}
                    isMulti={true}
                    noIndicator={false}
                    noSeparator={false}

                  />
                {/* <p style={{ color: "red" }}>{FormErrors["selectedLowProductivityReason_isEmpty"]}</p> */}
               </div>
              </div>
                </>
            )


            }
            


            { location.state ? 
            (
              <>
              <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="isActive" className="mr-2">
                  Is Active
                </label>
                <input
                  id="isActive"
                  type="checkbox"
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="isActive"
                  checked={isActive}
                />
              </div>
            </div></>
            ):
            (<></>)
            }

            

            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group">
                  <label>
                    Remark <sup>*</sup>
                  </label>
                  <InputForm
                      placeholder={""}
                      isDisabled={location.state? true : false}
                      textArea={true}
                      value={remark}
                      rows={4}
                      onChange={(event) =>
                        handleTextEvent(event, "remark")
                      }
                   />
                <p style={{ color: "red" }}>{FormErrors["remark_isEmpty"]}</p>
              </div>
            </div>

            {/* <div className="row"> */}
              <div className="col-lg-12">
                <div className="d-flex justify-content-between">
                  <div>
                    <button onClick={() => navigate(-1)} className="btn btn-reset">
                      <i className="fa fa-chevron-left"></i>
                    </button>
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      onClick={(event) => onClickFunction(event, "reset")}
                      className="btn btn-reset"
                      disabled = {location.state? true : false}
                    >
                      Reset
                    </button>

                    <button
                      onClick={(event) => onClickFunction(event, "submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            {/* </div> */}

            <div className="col-lg-12 mt-3">
              <DynamicGrid
                options={options}
                data={innerGridData}
                columns={gridColumns}
              />
           </div>

        </div>

      </div>
    </>
  )
}

export default ProductivityCreate
